import React, { useState } from "react";
import {
  Button,
  Input,
  Space,
  Select,
  Modal,
  Form,
  Switch,
  Divider,
  Typography,
  Radio,
  Card,
  Spin,
} from "antd";
import {
  PlusOutlined,
  SettingOutlined,
  EyeOutlined,
  BellOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setBoardView, setFilters } from "../ducks/boardReducer";

const { Option } = Select;
const { Text, Title } = Typography;

export default function TopBar({ showSearch, ticketCount, loading }: any) {
  console.log("🚀 ~ TopBar ~ loader:", loading);
  const [openPreferences, setOpenPreferences] = useState(false);
  const [preferencesForm] = Form.useForm();
  const navigate = useNavigate();

  const filters = useSelector((state: any) => state.board.filters);
  const boardView = useSelector((state: any) => state.board.boardView);

  const dispatch = useDispatch();

  const [preferences, setPreferences] = useState({
    theme: "system",
    compactView: false,
    showAvatars: true,
    showDescriptions: false,
    dateFormat: "short",
    timeFormat: "12h",
  });

  const handlePreferencesOk = () => {
    preferencesForm.validateFields().then((values) => {
      setPreferences(values);
      setOpenPreferences(false);
    });
  };
  return (
    <>
      <div
        style={{
          position: "sticky",
          top: 0,
          backdropFilter: "blur(8px)",
          padding: "24px 0",
          borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Title level={2} className={`mb-0`}>
            Tickets
          </Title>

          <Text style={{ color: "#8c8c8c", fontSize: "24px" }}>
            {ticketCount}
          </Text>
          {loading && <Spin size="small" />}
        </div>

        <Space wrap size="middle">
          {showSearch && (
            <Input
              prefix={<SearchOutlined />}
              placeholder="Search tickets..."
              value={filters.search}
              onChange={(e) => dispatch(setFilters({ search: e.target.value }))}
              style={{ marginTop: 4 }}
            />
          )}

          {/* <Select
            value={boardView}
            onChange={(v) => dispatch(setBoardView(v))}
            style={{
              width: 140,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
            }}
          >
            <Option value="board">Board View</Option>
            <Option value="list">List View</Option>
          </Select> */}

          {/* <Button
            icon={<SettingOutlined />}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.6)",
            }}
            onClick={() => setOpenPreferences(true)}
          >
            Preferences
          </Button> */}

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setTimeout(() => {
                navigate("/ticketing/new-ticket");
              }, 500);
            }}
          >
            New Issue
          </Button>
        </Space>
      </div>

      <Modal
        title="User Preferences"
        open={openPreferences}
        onOk={handlePreferencesOk}
        onCancel={() => setOpenPreferences(false)}
        width={700}
        okText="Save Preferences"
        cancelText="Cancel"
        styles={{
          body: {
            padding: "16px 0",
            backgroundColor: "transparent",
          },
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
          },
        }}
      >
        <Form
          form={preferencesForm}
          layout="vertical"
          initialValues={preferences}
        >
          <Divider orientation="left">
            <EyeOutlined style={{ marginRight: 8 }} />
            Display
          </Divider>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
            }}
          >
            <Card
              size="small"
              title="Theme & Appearance"
              style={{ gridColumn: "1 / -1" }}
              styles={{
                body: {
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                },
              }}
            >
              <Form.Item label="Theme" name="theme">
                <Radio.Group>
                  <Radio value="light">Light</Radio>
                  <Radio value="dark">Dark</Radio>
                  <Radio value="system">System</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item name="compactView" valuePropName="checked">
                <Switch />
                <Text style={{ marginLeft: 8 }}>Compact View</Text>
              </Form.Item>

              <Form.Item name="showAvatars" valuePropName="checked">
                <Switch defaultChecked />
                <Text style={{ marginLeft: 8 }}>Show User Avatars</Text>
              </Form.Item>

              <Form.Item name="showDescriptions" valuePropName="checked">
                <Switch />
                <Text style={{ marginLeft: 8 }}>Show Descriptions</Text>
              </Form.Item>
            </Card>

            <Card
              size="small"
              title="Date & Time Format"
              styles={{
                body: {
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                },
              }}
            >
              <Form.Item label="Date Format" name="dateFormat">
                <Radio.Group>
                  <Radio value="short">Short (MM/DD/YYYY)</Radio>
                  <Radio value="medium">Medium (MMM DD, YYYY)</Radio>
                  <Radio value="long">Long (MMMM DD, YYYY)</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item label="Time Format" name="timeFormat">
                <Radio.Group>
                  <Radio value="12h">12 Hour</Radio>
                  <Radio value="24h">24 Hour</Radio>
                </Radio.Group>
              </Form.Item>
            </Card>

            <Card
              size="small"
              title="Notifications"
              styles={{
                body: {
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                },
              }}
            >
              <Form.Item name="emailNotifications" valuePropName="checked">
                <Switch defaultChecked />
                <Text style={{ marginLeft: 8 }}>Email Notifications</Text>
              </Form.Item>

              <Form.Item name="browserNotifications" valuePropName="checked">
                <Switch defaultChecked />
                <Text style={{ marginLeft: 8 }}>Browser Notifications</Text>
              </Form.Item>

              <Form.Item name="desktopNotifications" valuePropName="checked">
                <Switch />
                <Text style={{ marginLeft: 8 }}>Desktop Notifications</Text>
              </Form.Item>
            </Card>
          </div>

          <Divider orientation="left">
            <BellOutlined style={{ marginRight: 8 }} />
            Notification Preferences
          </Divider>

          <Card
            size="small"
            styles={{
              body: {
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              },
            }}
          >
            <Form.Item label="Notify me about">
              <Select defaultValue="all">
                <Option value="all">All activity</Option>
                <Option value="mentions">Mentions only</Option>
                <Option value="none">None</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Email frequency">
              <Select defaultValue="immediately">
                <Option value="immediately">Immediately</Option>
                <Option value="daily">Daily digest</Option>
                <Option value="weekly">Weekly digest</Option>
              </Select>
            </Form.Item>
          </Card>
        </Form>
      </Modal>
    </>
  );
}
